import RequestError from '@/plugins/sdk/Errors/RequestError'

export default class extends RequestError {
  constructor (resource, request, response, ...params) {
    super(resource, request, response, params)
  }
}
